// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getVideoEmbeddedUrl } from "@conklin/XDL/Utilities";
import React, { useEffect, useRef } from "react";

export interface VideoProps {
    src: string;
    controls?: boolean;
    extension?: string;
    autoPlay?: boolean;
    muted?: boolean;
    repeat?: boolean;
}

type Props = VideoProps;

const Video: React.FC<Props> = ({ src, controls = true, muted, extension = "mp4", autoPlay, repeat }) => {
    const videoRef = useRef<HTMLVideoElement | null>(null);
    useEffect(() => {
        if (autoPlay && videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
            videoRef.current.play();
        }
    }, [autoPlay]);

    if (!src) {
        return null;
    }

    const withExtension = src.includes(extension);
    const embeddedURL = !withExtension ? getVideoEmbeddedUrl(src) : "";
    return withExtension ? (
        <video key={src} ref={videoRef} width="100%" height="100%" controls={controls} muted={muted} loop={repeat}>
            <track kind="captions" src="sampleCaptions.vtt" srcLang="en" />
            <source src={src} type={`video/${extension}`}></source>
        </video>
    ) : (
        <iframe
            src={embeddedURL}
            frameBorder="0"
            allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
            allowFullScreen
            width="100%"
            height="100%"
        />
    );
};

export default Video;
